

































































































































































































































import EventBus from '@/eventBus.js';
import i18n from 'vue-i18n';
import { EventTicket, TaxRate } from '@/types/GlobalTypes';
import { get } from 'lodash';
import axios from 'axios';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoCardTicket from '@/components/Molecules/co-card-ticket/CoCardTicket.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';

import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoCardBillingAddress from '@/components/Organisms/co-card-billing-address/CoCardBillingAddress.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import { Space } from '@/types/GlobalTypes';
interface BillingAddress {
    Phone?: string;
    Company?: string;
    AdditionalInfo?: string;
    Address: string;
    PostalCode: string;
    City: string;
    Country: string;
    VATNumber?: string;
}

export default {
    name: 'CoEventTicketCheckout',
    components: {
        CoText,
        CoCardTicket,
        CoModal,
        CoHeadline,
        CoButton,
        CoCheckbox,
        CoCardBillingAddress,
        CoCard,
        CoLink,
        CoRoundButton,
    },
    props: {
        eventName: {
            type: String,
            required: false,
            default: '',
        },
        eventLocationAddress: {
            type: String,
            required: false,
            default: '',
        },
        eventID: {
            type: String,
            required: true,
        },
        eventStartDate: {
            type: [String, Number, Date],
            required: false,
            default: null,
        },
        eventEndDate: {
            type: [String, Number, Date],
            required: false,
            default: null,
        },
        eventSlug: {
            type: String,
            required: true,
        },
        tickets: {
            type: Array as () => EventTicket[],
            required: false,
            default: () => [] as EventTicket[],
        },
        taxRates: {
            type: Array as () => Array<any> | null,
            default: () => [],
        },
        currency: {
            type: String,
            required: false,
            default: '',
        },
        ticketPurchaseState: {
            type: String,
            required: false,
            default: 'buy',
            validator(value: string) {
                return ['buy', 'success', ''].includes(value);
            },
        },
        originCommunity: {
            type: Object as () => Space | null,
            default: null,
        },
        currentCommunityID: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            step: 1, // 1 - select tickets, 2 - billing address, 3 - Checkout view
            loading: false,
            selectedTicket: null as EventTicket | null,
            acceptTermsAndConditions: false,
            ticketSelections: {} as Record<string, { ticket: EventTicket; quantity: number }>,
            activeTermsTicket: null as EventTicket | null,
            loadingMyTicket: false,
            myTicket: null,
            maxTotalTickets: 25,

            billingAddress: this.$store?.state?.me?.Address
                ? (this.$store.state.me.Address as BillingAddress)
                : ({} as BillingAddress),
        };
    },
    watch: {},
    computed: {
        // Read space terms once from the store to avoid per-checkout fetches.
        // Also expose a store-backed "loaded" flag so the UI can treat
        // "not loaded yet" as a blocking state when space terms may apply.
        spaceTermsAndConditionsLoaded() {
            const state = this.$store && this.$store.state;
            if (!state || typeof state.termsAndConditionsLoaded !== 'boolean') {
                // Default to "loaded" to remain backward compatible if the
                // store does not expose a dedicated loaded flag yet.
                return true;
            }
            return state.termsAndConditionsLoaded;
        },
        spaceTermsAndConditions() {
            return this.$store.state.termsAndConditions?.Content || '';
        },
        selectedTickets() {
            return Object.values(this.ticketSelections).filter(
                (item) => (item as { ticket: EventTicket; quantity: number }).quantity > 0
            );
        },
        hasSelectedTickets() {
            return this.selectedTickets.length > 0;
        },
        totalSelectedQuantity() {
            return this.selectedTickets.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
        },
        primaryTicket() {
            if (this.selectedTicket) {
                return this.selectedTicket;
            }
            if (this.selectedTickets.length > 0) {
                return this.selectedTickets[0].ticket;
            }
            return null;
        },

        ticketsWithTerms() {
            return this.selectedTickets.filter((item) => item.ticket.TermsAndConditions?.trim());
        },
        termsListItems() {
            const items = [];

            // If space terms may exist but have not finished loading yet,
            // return a placeholder item so callers can treat this as a
            // blocking state (e.g. disable Next/Checkout or show loading).
            if (!this.spaceTermsAndConditionsLoaded) {
                items.push({
                    key: 'space-terms-loading',
                    label: this.$t('labels.termsandconditions'),
                    ticket: null,
                    loading: true,
                });
                return items;
            }

            if (this.spaceTermsAndConditions?.trim()) {
                items.push({ key: 'space-terms', label: this.$t('labels.termsandconditions'), ticket: null });
            }
            this.ticketsWithTerms.forEach((item) => {
                items.push({ key: item.ticket.ID, label: item.ticket.Name, ticket: item.ticket });
            });
            return items;
        },
        ticketsWithCancellation() {
            return this.selectedTickets.filter((item) => item.ticket.CancellationNotice);
        },
        hasTermsAndConditions() {
            const hasTicketTerms = this.selectedTickets.some((item) => item.ticket.TermsAndConditions?.trim());
            return hasTicketTerms || !!this.spaceTermsAndConditions?.trim();
        },
        termsAndConditionsContent() {
            if (this.activeTermsTicket && this.activeTermsTicket.TermsAndConditions) {
                return this.activeTermsTicket.TermsAndConditions;
            }
            return this.spaceTermsAndConditions;
        },
        cancellationNoticeDays() {
            if (!this.ticketsWithCancellation.length) {
                return null;
            }
            const noticeDays = this.ticketsWithCancellation
                .map((item) => Number(item.ticket.CancellationNotice) || 0)
                .filter((value) => value > 0);
            if (!noticeDays.length) {
                return this.primaryTicket?.CancellationNotice || null;
            }
            return Math.max(...noticeDays);
        },
        canIClickNext() {
            if (!this.hasSelectedTickets) {
                return false;
            }

            const needsTerms = this.hasTermsAndConditions;
            if (needsTerms && !this.acceptTermsAndConditions) {
                return false;
            }

            return true;
        },
        canICheckout() {
            if (!this.hasSelectedTickets || (this.hasTermsAndConditions && !this.acceptTermsAndConditions)) {
                return false;
            }

            return true;
        },

        orderTotals() {
            let subtotalInCents = 0;
            let totalInCents = 0;
            const taxMap = new Map<
                string,
                { id: string; name: string; percentage: number; inclusive: boolean; amountInCents: number }
            >();

            const taxRates = this.taxRates || [];

            this.selectedTickets.forEach((item) => {
                const priceInCents = item.ticket.PriceInCents ? item.ticket.PriceInCents : 0;
                const quantity = item.quantity ? item.quantity : 0;
                const lineGross = priceInCents * quantity;
                const taxRate = taxRates.find((rate) => rate.ID === item.ticket.TaxRateID);
                const percentage = taxRate?.Percentage ? taxRate.Percentage : 0;

                if (taxRate && percentage > 0) {
                    if (taxRate.Inclusive) {
                        const lineNet = Math.round(lineGross / (1 + percentage / 100));
                        const lineTax = lineGross - lineNet;
                        subtotalInCents += lineNet;
                        totalInCents += lineGross;

                        const taxKey = `${taxRate.ID || taxRate.Name || percentage}-inclusive`;
                        const existing = taxMap.get(taxKey);
                        if (existing) {
                            existing.amountInCents += lineTax;
                        } else {
                            taxMap.set(taxKey, {
                                id: taxKey,
                                name: taxRate.Name || this.$t('labels.vat'),
                                percentage,
                                inclusive: true,
                                amountInCents: lineTax,
                            });
                        }
                    } else {
                        const lineNet = lineGross;
                        const lineTax = Math.round(lineNet * (percentage / 100));
                        subtotalInCents += lineNet;
                        totalInCents += lineNet + lineTax;

                        const taxKey = `${taxRate.ID || taxRate.Name || percentage}-exclusive`;
                        const existing = taxMap.get(taxKey);
                        if (existing) {
                            existing.amountInCents += lineTax;
                        } else {
                            taxMap.set(taxKey, {
                                id: taxKey,
                                name: taxRate.Name || this.$t('labels.vat'),
                                percentage,
                                inclusive: false,
                                amountInCents: lineTax,
                            });
                        }
                    }
                } else {
                    subtotalInCents += lineGross;
                    totalInCents += lineGross;
                }
            });

            return {
                subtotalInCents,
                totalInCents,
                taxLines: Array.from(taxMap.values()),
            };
        },
        formattedSubtotal() {
            return this.formatPriceFromCents(this.orderTotals.subtotalInCents);
        },
        formattedTotal() {
            return this.formatPriceFromCents(this.orderTotals.totalInCents);
        },
        taxLines() {
            return this.orderTotals.taxLines.map((line) => {
                const label = `${line.name} (${line.percentage}%)`;
                return {
                    id: line.id,
                    label,
                    amount: this.formatPriceFromCents(line.amountInCents),
                };
            });
        },

        currencyChar() {
            if (!this.currency) {
                return '€';
            }

            const currency = this.currency.toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        listTickets() {
            // Filter out deleted tickets and sort by price in ascending order also filter sold out tickets as last
            return this.tickets
                .filter((ticket) => !ticket.Deleted)
                .sort((a, b) => a.PriceInCents - b.PriceInCents)
                .sort((a, b) => (a.SoldOut ? 1 : 0) - (b.SoldOut ? 1 : 0));
        },
    },
    mounted() {},
    methods: {
        get,
        formatPriceFromCents(cents: number) {
            const priceInCents = cents ? cents : 0;
            let priceStr = (priceInCents / 100).toFixed(2);
            priceStr = priceStr.replace('.', ',');
            return `${priceStr} ${this.currencyChar}`;
        },
        updateTicketQuantity(payload) {
            if (!payload || !payload.id) {
                return;
            }

            const quantity = Number(payload.quantity) || 0;
            const currentQuantity = this.ticketSelections[payload.id]?.quantity || 0;
            const totalExcludingCurrent = this.totalSelectedQuantity - currentQuantity;
            const allowedQuantity = Math.max(this.maxTotalTickets - totalExcludingCurrent, 0);
            const nextQuantity = Math.min(quantity, allowedQuantity);

            if (quantity > allowedQuantity) {
                this.handleMaxTotalReached();
            }

            if (nextQuantity > 0) {
                this.$set(this.ticketSelections, payload.id, {
                    ticket: payload.ticket,
                    quantity: nextQuantity,
                });
                if (!this.selectedTicket) {
                    this.selectedTicket = payload.ticket;
                }
            } else {
                this.$delete(this.ticketSelections, payload.id);
                if (this.selectedTicket && this.selectedTicket.ID === payload.id) {
                    this.selectedTicket = null;
                }
            }
        },
        getSelectedTicketQuantity(ticketId: string) {
            if (!ticketId) {
                return 0;
            }
            return this.ticketSelections[ticketId]?.quantity || 0;
        },
        handleMaxTotalReached() {
            EventBus.$emit('ERROR', {
                Message: this.$t('messages.maxTicketsReached', { max: this.maxTotalTickets }),
            });
        },
        buildOrderRequest() {
            const tickets = this.selectedTickets
                .map((item) => ({
                    TicketTypeID: item.ticket.ID,
                    Quantity: item.quantity,
                }))
                .filter((ticket) => ticket.TicketTypeID);

            const primaryTicketId = this.primaryTicket?.ID;
            const successURL = `${window.location.origin}/event/${this.eventSlug}?tp=success${
                primaryTicketId ? `&ticket_type_id=${primaryTicketId}` : ''
            }`;
            const cancelURL = `${window.location.origin}/event/${this.eventSlug}?tp=cancel${
                primaryTicketId ? `&ticket_type_id=${primaryTicketId}` : ''
            }`;

            return {
                tickets,
                event_id: this.eventID,
                success_url: successURL,
                cancel_url: cancelURL,
            };
        },
        submitOrder() {
            const req = this.buildOrderRequest();
            axios({
                method: 'POST',
                url: '/event/ticket',
                data: req,
            })
                .then((response) => {
                    // redirect to payment page
                    const paymentURL = get(response, 'data.ticket.PaymentURL', '');
                    if (paymentURL) {
                        window.location.href = paymentURL;
                        this.loading = false;
                    } else {
                        this.$emit('success');
                        this.hideModal();
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(error);
                    EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                })
                .finally(() => {});
        },
        next() {
            // if Price is 0 skip billing address part
            if (this.orderTotals.totalInCents === 0) {
                this.loading = true;
                this.submitOrder();
            } else {
                this.step = 2;
            }
        },
        showEventDetails() {
            // replace url
            this.$router.replace(`/event/${this.eventSlug}`);

            // hide modal
            this.$refs['co-event-ticket-checkout'].hide();
        },
        hideModal() {
            this.$refs['co-event-ticket-checkout'].hide();
            this.selectedTicket = null;
            this.acceptTermsAndConditions = false;
            this.ticketSelections = {};
            this.activeTermsTicket = null;
            this.step = 1;
        },
        openTermsList() {
            if (!this.termsListItems.length) {
                return;
            }
            this.$refs['terms-and-conditions-list'].show();
        },
        openTermsDetail(ticket: EventTicket | null) {
            this.activeTermsTicket = ticket;
            this.$refs['terms-and-conditions-detail'].show();
        },
        openModal() {
            if (this.$store?.state?.isInMobile) {
                // replace url quiry params with resource id
                const urltoResource = `/event/${this.eventSlug}?tp=buy`; // need to append a first query param because mobile app adds '&apptoken=...' automatically
                const queryParam = {
                    ...this.$route.query,
                    m: 'mobile',
                    openinbrowser: urltoResource,
                    t: new Date().getTime(),
                };
                this.$router.push({ query: queryParam });
                return;
            }

            this.$refs['co-event-ticket-checkout'].show();
        },
        selectTicket(ticket: EventTicket) {
            if (this.loading) {
                return;
            }
            if (!ticket.PriceInCents) {
                ticket.PriceInCents = 0;
            }

            this.selectedTicket = ticket;
        },
        createOrder() {
            this.loading = true;
            if (!this.billingAddress || !this.billingAddress.Address) {
                this.submitOrder();
                return;
            }

            // call to update billing address
            const data = { Address: this.billingAddress };
            axios({
                method: 'PUT',
                url: '/dashboard/me-billing',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
                data,
            })
                .then((response) => {
                    // checkout call
                    this.submitOrder();
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);

                    if (get(error, 'response.data', '').match('tax_id_invalid')) {
                        EventBus.$emit('ERROR', {
                            Message: this.$t('labels.vatid') + ' ' + this.$t('errors.invalid'),
                        });
                    } else {
                        EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                    }
                })
                .finally(() => {});
        },

        saveBillingAddressData(billingAddress) {
            this.billingAddress = billingAddress;
            const data = { Address: billingAddress };
            return new Promise<void>((resolve, reject) => {
                axios({
                    method: 'PUT',
                    url: '/dashboard/me-billing',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data,
                })
                    .then((response) => {
                        EventBus.$emit('INFO', { Message: this.$t('messages.changessaved') });
                    })
                    .catch((error) => {
                        console.log(error);
                        if (get(error, 'response.data', '').match('tax_id_invalid')) {
                            EventBus.$emit('ERROR', {
                                Message: this.$t('labels.vatid') + ' ' + this.$t('errors.invalid'),
                            });
                        } else {
                            EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                        }
                    })
                    .finally(() => {
                        resolve();
                    });
            });
        },
    },
};
